/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactFlow, { Background, ControlButton, Controls, useZoomPanHelper } from 'react-flow-renderer';
import { useTranslation } from 'react-i18next';
import Widget from '../../widget';
import {
  useNodes,
  ELEMENTS_TO_KEEP,
  DEFAULT_NODE_HEIGHT,
  DEFAULT_NODE_WIDTH,
  GAP,
  DEFAULT_ZOOM,
  getZoom,
  MIN_ZOOM,
} from './helper';
import Style, { Container } from './style';
import Sider from './sider';
import { ExpandOutlined } from '@ant-design/icons';
import ComponentWithFocus from '../../components/component-with-focus';

export default function BeneficialOwnership({
  data = { stakeholders: [], beneficiaries: [], ownData: [], sources: [] },
  redirectToView = () => { },
  getOption = () => { },
  isSingleSource = true,
  selectedSource = null,
  mode = '',
  loading,
}) {
  const { t } = useTranslation();
  const ref = useRef();
  const { setCenter, zoomTo, transform } = useZoomPanHelper();
  const [initialCenterDone, setInitialCenterDone] = useState(false);
  const [closed, setClosed] = useState(false);
  const {
    elements,
    beneficiariesData,
    stakeholdersData,
    activeNode,
    setActiveNode,
    isCooperative,
  } = useNodes({ ...data, t, getOption });

  const onLoad = () => { };

  const recenter = (nods) => {
    const nodes = nods || elements.filter((el) => !el.source && !el.target);
    if (ref && ref.current && setCenter && nodes.length) {
      const contWidth = ref.current.clientWidth;
      const contHeight = ref.current.clientHeight;
      const exEs = nodes.map((n) => n.position.x);
      const yS = nodes.map((n) => n.position.y).filter((a) => a !== -10000);
      const min = Math.min(...exEs);
      const max = Math.max(...exEs);
      const minY = Math.min(...yS);
      const maxY = Math.max(...yS);
      let zoom = getZoom(DEFAULT_ZOOM, min, max, minY, maxY, contWidth, contHeight, setCenter, zoomTo);
      if (zoom) {
        if ((min * -1) === max || (nodes.length - 2) <= 1 || ((stakeholdersData?.min || 0) * -1) === beneficiariesData?.max) {
          setCenter(75, 20);
          zoomTo(zoom);
        } else if ((min * -1) > max) {
          // const x = contWidth - (max * zoom) - (DEFAULT_NODE_WIDTH * zoom) - GAP;
          // transform({ x, y: (contHeight / 2) - (DEFAULT_NODE_HEIGHT / 2 * zoom), zoom });
          setCenter(75, 20);
          zoomTo(zoom);
        } else if ((min * -1) < max) {
          // const x = (min * -1 * zoom) + GAP;
          // transform({ x, y: (contHeight / 2) - (DEFAULT_NODE_HEIGHT / 2 * zoom), zoom });
          setCenter(75, 20);
          zoomTo(zoom);
        }
      } else {
        zoom = MIN_ZOOM;
        // transform({ x: (contWidth / 2) - (DEFAULT_NODE_WIDTH / 2 * zoom), y: (contHeight / 2) - (DEFAULT_NODE_HEIGHT / 2 * zoom), zoom });
        setCenter(75, 20);
        zoomTo(zoom);
      }
    }
  };

  useEffect(() => {
    const nodes = elements.filter((el) => !el.source && !el.target);

    if (!initialCenterDone && nodes.length) {
      recenter(nodes);
      setInitialCenterDone(true);
    }
    if (!nodes.length) {
      setInitialCenterDone(false);
    }
  }, [ref, setCenter, elements]);

  const allElements = useMemo(() => data.ownData ? [
    ...elements,
    ...ELEMENTS_TO_KEEP,
  ] : [], [elements, data]);

  const rfOnClick = useCallback((e) => {
    if (activeNode && e.target.className === 'react-flow__pane') {
      setActiveNode(null);
    }
  }, [activeNode]);

  const clear = useCallback(() => {
    setActiveNode(null);
    setClosed(true);
  }, []);

  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => setActiveNode(null),
  }), [closed]);

  return (
    <Widget
      className="beneficial"
      title={t('Beneficial Ownership')}
      loading={loading}
    >
      <ComponentWithFocus actions={actions}>
        <Container>
          <Style ref={ref}>
            <div className="header header-left">
              <label className="arrow">←</label>
              <label>{t(isCooperative ? 'Founding Members' : 'Shareholders')}</label>
            </div>
            <div className="header header-right">
              <label>{t('Other Beneficiaries')}</label>
              <label className="arrow">→</label>
            </div>
            <ReactFlow
              onLoad={onLoad}
              elements={allElements}
              onClick={rfOnClick}
              nodesDraggable={false}
            >
              <Background color="black" gap={10} />
              <Controls
                showFitView={false}
                showInteractive={false}
              >
                <ControlButton onClick={() => recenter()}>
                  <ExpandOutlined />
                </ControlButton>
              </Controls>
            </ReactFlow>
          </Style>
          {activeNode && (
            <Sider
              sources={data.sources}
              clear={clear}
              element={activeNode}
              t={t}
              mode={mode}
              isCooperative={isCooperative}
              redirectToView={redirectToView}
              getOption={getOption}
              isSingleSource={isSingleSource}
              selectedSource={selectedSource}
            />
          )}
        </Container>
      </ComponentWithFocus>
    </Widget>
  );
}
